'use client';

import * as React from 'react';

import { Button } from 'react-aria-components';

import { Download } from '@avodah-inc/ui/icons';
import { cn } from '@avodah-inc/ui/utils';

import { Typography } from '../typography';

export type PatientCardInfo = {
  isHistoryView: boolean;
  fileName: string;
  fileSize: string;
  uploadedBy: string;
  uploadedDateTime: string;
  onDownloadClicked?: () => void;
};

export type PatientDataCardProps = React.HTMLAttributes<HTMLDivElement> & {
  patientCardInfo: PatientCardInfo;
};

export const PatientDataCard = React.forwardRef<
  HTMLDivElement,
  PatientDataCardProps
>(({ patientCardInfo, ...props }, ref) => {
  return (
    <div ref={ref} className="flex w-full flex-col" {...props}>
      {!patientCardInfo.isHistoryView ? (
        <Typography className="text-onLight-high" variant="h4">
          File added
        </Typography>
      ) : null}
      <div className="justify-left border-table-border bg-table-background mt-2 flex w-full rounded-md border p-4">
        {!patientCardInfo.isHistoryView &&
          patientCardInfo.onDownloadClicked && (
            <Button
              className="focus:outline-none active:outline-none"
              onPress={patientCardInfo.onDownloadClicked}
            >
              <Download className="flex-none" width={40} height={42} />
            </Button>
          )}
        <div className="flex-1 flex-col gap-1">
          <Typography
            className={cn({
              'text-onLight-medium': patientCardInfo.isHistoryView,
              'text-onLight-high': !patientCardInfo.isHistoryView,
            })}
            variant="h4"
          >
            {patientCardInfo.fileName}
          </Typography>
          <Typography
            className={cn({
              'text-onLight-medium': patientCardInfo.isHistoryView,
              'text-onLight-high': !patientCardInfo.isHistoryView,
            })}
            variant="body5"
          >
            {patientCardInfo.fileSize}
          </Typography>
        </div>
        <Typography
          className={cn('flex-1 justify-items-end text-right', {
            'text-onLight-medium': patientCardInfo.isHistoryView,
            'text-onLight-high': !patientCardInfo.isHistoryView,
          })}
          variant="body5"
        >
          Uploaded by {` ${patientCardInfo.uploadedBy}`}{' '}
          {patientCardInfo.uploadedDateTime}
        </Typography>
      </div>
    </div>
  );
});

PatientDataCard.displayName = 'PatientDataCard';
